import React from "react";

const Textarea = ({ error, label, isRequired, id, name, className = "", placeholder, register, ...rest }) => {
  return (
    <div>
      {label && (
        <label
          htmlFor={id}
          className="flex-align gap-4 text-sm font-heading-two text-gray-900 fw-semibold mb-4"
        >
          {label}
          {isRequired && <span className="text-danger">*</span>}
        </label>
      )}
      {name && (
        <textarea
          className={`${className} common-input px-16`}
          id={id}
          placeholder={placeholder}
          {...rest}
          {...register(name)}
        />
      )}
      {!name && (
        <textarea className={`${className} common-input px-16`} id={id} placeholder={placeholder} {...rest} />
      )}
      {error && (
        <div className="mt-1">
          <p className="text-danger">{error?.message}</p>
        </div>
      )}
    </div>
  );
};

export default Textarea;
